import { createSvgIcon } from '@mui/material';
import Styled from './custom-styled-icon';

export const Printer = Styled(
    createSvgIcon(
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.0415 5.83334H13.9582V4.16667C13.9582 2.50001 13.3332 1.66667 11.4582 1.66667H8.5415C6.6665 1.66667 6.0415 2.50001 6.0415 4.16667V5.83334Z" stroke="#1F2125" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M13.3332 12.5V15.8333C13.3332 17.5 12.4998 18.3333 10.8332 18.3333H9.1665C7.49984 18.3333 6.6665 17.5 6.6665 15.8333V12.5H13.3332Z" stroke="#1F2125" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M17.5 8.33333V12.5C17.5 14.1667 16.6667 15 15 15H13.3333V12.5H6.66667V15H5C3.33333 15 2.5 14.1667 2.5 12.5V8.33333C2.5 6.66666 3.33333 5.83333 5 5.83333H15C16.6667 5.83333 17.5 6.66666 17.5 8.33333Z" stroke="#292D32" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M14.1668 12.5H13.1585H5.8335" stroke="#292D32" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M5.8335 9.16667H8.3335" stroke="#292D32" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        ,
        'Printer'
    )
);

export default Printer;
